module.exports = __webpack_public_path__ + "static/AvenirNextLTPro-BoldCn-49351c11871780e73fc45c22d38a7c5a.woff";